import React from "react";
import { CircleAlert } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const warningSigns = [{
  title: "Artisanal European Pantry",
  description: "Discover a curated selection of imported olive oils, aged vinegars, and authentic pasta from the heart of Europe. Perfect for elevating your home cooking with genuine flavors."
}, {
  title: "European Pastries & Sweets",
  description: "Our morning selection features buttery croissants, seasonal fruit tarts, and traditional European sweets, sourced fresh from trusted local bakeries to pair perfectly with our signature espresso blends."
}, {
  title: "Specialty Coffee & Matcha",
  description: "Experience the art of the pour. From velvety lattes to ceremonial grade matcha, our baristas craft every drink with precision and passion for the perfect morning ritual."
}, {
  title: "Gourmet Focaccia Deli",
  description: "Focaccia bread serves as the canvas for our premium deli sandwiches. Featuring imported meats, fresh cheeses, and flavorful spreads for a superior lunch."
}, {
  title: "Seasonal Market Finds",
  description: "We source the finest seasonal ingredients and unique imported goods. From holiday specialties to summer preserves, there is always something new to discover on our shelves."
}, {
  title: "Curated Gift Baskets",
  description: "Share the taste of M&M Café & Market. We assemble custom collections of our favorite market treasures, perfect for housewarmings, holidays, or showing appreciation."
}];
export default function MarketTreasures() {
  return <section data-section-id="256041" id="market-treasures" className="bg-background text-foreground">
      <div className="bg-accent/30 py-16 md:py-24">
        <div className="page-container">
          <div className="mx-auto max-w-3xl text-center mb-12 md:mb-16">
            <span className="mb-3 block text-sm font-semibold uppercase tracking-widest text-secondary">
              The Market Collection
            </span>
            <h2 className="mb-4 font-default text-4xl font-medium text-foreground md:text-5xl">
              Discover Our Market Treasures
            </h2>
            <p className="text-lg font-default text-muted-foreground">
              A hand-picked selection of European delicacies and café favorites 
              brought from our neighborhood to your kitchen.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
            {warningSigns.map((sign, i) => <Card key={i} data-index={i} className="border-none bg-card shadow-sm transition-all duration-400 hover:shadow-md hover:bg-card/80 rounded-xl">
                <CardHeader className="pb-4">
                  <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-secondary/10">
                    <CircleAlert className="size-6 text-secondary" />
                  </div>
                  <CardTitle className="font-default text-xl leading-tight md:text-2xl text-foreground">
                    {sign.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm leading-relaxed text-muted-foreground md:text-base font-default">
                    {sign.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}